module.exports = __webpack_public_path__ + "static/media/kirigaya-suguha-lose.564b79e0.png";